import { useCallback, useState } from 'react';
import { useAppDispatch } from 'store/hooks';
import { updateDevice } from 'modules/devices/store/actions';
import { toast } from 'react-toastify';

export function useUpdateDevice(refetch: () => void) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const mutate = useCallback(
    async (id: number, params: Partial<{ name: string; tournament_id: number }>) => {
      setIsLoading(true);
      try {
        await dispatch(updateDevice({ id, params })).unwrap();
        toast.success('Устройство обновлено');
        refetch();
      } catch {
        toast.error('Не удалось обновить устройство');
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, refetch],
  );

  return { mutate, isLoading };
}
